import { getToken, axiosInstance } from './authService';

export const getMyTenants = async () => {
  const token = getToken();
  if (token) {
    const response = await axiosInstance.get(`/app/api/my-tenants/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }
  return [];
}

export const getMyProfile = async () => {
  const token = getToken();
  if (token) {
    const response = await axiosInstance.get(`/app/api/my-profile/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }
  return null;
};

export const getMyProfileV2 = async () => {
  const token = getToken();
  if (token) {
    const response = await axiosInstance.get(`/app/api/profile/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }
  return null;
};

export const getEvents = async (tenantId) => {
  const token = getToken();
  if (token) {
    const response = await axiosInstance.get(`/app/t:${tenantId}/api/v2/events/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.results;
  }
  return [];
};

export const getEventDetails = async (tenantId, eventId) => {
  const token = getToken();
  if (token) {
    const response = await axiosInstance.get(`/app/t:${tenantId}/api/v2/events/e:${eventId}/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }
  return null;
};

export const submitEventComment = async (tenantId, eventId, rating, comment) => {
  const token = getToken();
  if (token) {
    const response = await axiosInstance.post(
      `/app/t:${tenantId}/api/v2/events/e:${eventId}/user-states/feedback/`,
      {
        "feedback_value": rating,
        "comment": comment
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  }
  throw new Error('User is not authenticated');
};

export const getEventComments = async (tenantId, eventId) => {
  const token = getToken();
  if (token) {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

    const response = await axiosInstance.get(
      `/app/t:${tenantId}/api/v2/events/e:${eventId}/comments/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    );
    return response.data;
  }
  throw new Error('User is not authenticated');
};

export const submitUserStateAnswer = async (tenantId, eventId, answer) => {
  const token = getToken();
  if (token) {
    const payload = answer;
    const response = await axiosInstance.post(
        `/app/t:${tenantId}/api/v2/events/e:${eventId}/user-states/answers/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
    );
    return response.data;
  }
  throw new Error('User is not authenticated');
};